import { iframeDataBridge } from '@/iframe/iframeDataBridge';
import { authenticatedFetch, getApiUrl } from '@/utils/auth/authService';
import { log } from '@/utils/core/vueLogger.js';
import { CacheManager } from '@/utils/core/cacheManager.js';

const clusteringCache = new CacheManager('VueCache', 'cache', {
	maxAge: 24 * 60 * 60 * 1000,
	memoryCacheTTL: 30 * 60 * 1000,
	logCategory: 'Company',
	keyPrefix: () => `${iframeDataBridge.getCustomer() ?? 'unknown'}.${iframeDataBridge.getCurrentUser()?.id ?? 'unknown'}.companies.`,
});

export async function getCompanies(forceRefresh = false) {
	if (!forceRefresh && !clusteringCache.getFromMemory('all')) {
		try {
			const legacyData = await iframeDataBridge.getStorageAsync('COMPANIES');
			if (legacyData) {
				log('info', 'Company', '📦 Seeding Vue cache from legacy storage (COMPANIES)');
				await clusteringCache.put('all', legacyData);
				clusteringCache.setInMemory('all', legacyData);
				return legacyData;
			}
		} catch (legacyError) {
			log('warn', 'Company', `⚠️ Legacy storage check failed: ${legacyError.message}`);
		}
	}

	return clusteringCache.fetchOrCache('all', fetchCompaniesFromAPI, { forceRefresh, fallback: [], backgroundRefresh: true });
}

async function fetchCompaniesFromAPI() {
	const response = await authenticatedFetch(getApiUrl('Core/Companies'), { method: 'GET' }, 'tokenSales');

	if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

	const companies = await response.json();
	log('success', 'Company', `✅ Fetched ${companies.length} companies`);
	return companies;
}

export async function refreshCompanies() {
	clusteringCache.clearMemory();
	await clusteringCache.clear();
}
